export class TableScroller {

  constructor(height, scrollHeight, scrollTop) {
    this.height = height;
    this.scrollHeight = scrollHeight;
    this.scrollTop = scrollTop;
  }

  static createNil () {
    return new TableScroller(0, 0, 0);
  }

  static createScroller = (element) => {
    if (!element) {
      return this.createNil();
    }
    const height = element.clientHeight ? element.clientHeight : element.getBoundingClientRect().height;
    const scrollHeight = element.scrollHeight;
    const scrollTop = element.scrollTop;
    // console.log("Log: TableScroller -> staticcreateScroller -> height", height, scrollHeight);
    return new TableScroller(height, scrollHeight, scrollTop);
  }
  get maxScrollTop() {
    return this.scrollHeight - this.height;
  }
  get scrollPercent() {
    return this.scrollTop / (this.scrollHeight - this.height) * 100; 
  }
}